import React from "react";
import L, { LatLngTuple } from "leaflet";

type BoundaryData = {
  type?: string;
  geometry?: {
    type?: string;
    coordinates?: any;
  };
  features?: BoundaryData[];
};

function getBoundaryRings(boundary: BoundaryData): LatLngTuple[][] {
  const geometries = boundary.features?.length
    ? boundary.features.map((feature) => feature.geometry).filter(Boolean)
    : [boundary.geometry];

  return geometries.flatMap((geometry: any) => {
    if (geometry?.type === "Polygon") {
      return geometry.coordinates?.[0] ? [geometry.coordinates[0]] : [];
    }

    if (geometry?.type === "MultiPolygon") {
      return (geometry.coordinates || []).map((polygon: any[]) => polygon[0]).filter(Boolean);
    }

    return [];
  }).map((ring: Array<[number, number]>) =>
    ring.map(([longitude, latitude]) => [latitude, longitude] as LatLngTuple)
  );
}

export function svgCityOutline(SVGOutline: BoundaryData, layerShapeGroupRef: React.MutableRefObject<L.LayerGroup<any>>, svgOutnlineStyle: { fillColor: string; color: string; weight: number; opacity: number; fillOpacity: number; }, mapRef: React.MutableRefObject<L.Map | undefined>) {
  if (SVGOutline && layerShapeGroupRef && mapRef.current) {
    const cityRings = getBoundaryRings(SVGOutline);
    const worldRing: LatLngTuple[] = [
      [-90, -180],
      [-90, 180],
      [90, 180],
      [90, -180],
    ];

    // The city boundary is a hole in the outer mask, so only the area outside
    // the city is shaded while the boundary itself remains visible.
    const cityMask = L.polygon([worldRing, ...cityRings], {
      ...svgOutnlineStyle,
      pane: "city-outline",
      fillRule: "evenodd",
    });
    cityMask.addTo(layerShapeGroupRef.current);
  }
}
